import type { RouterConfig } from '@nuxt/schema';
import { ERouteNames } from '~/types/enums';

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
    routes: (_routes) => [
        {
            name: ERouteNames.HOME,
            path: '/',
            component: () => import('~/pages/Homepage.vue').then(r => r.default || r)
        },
        {
            name: ERouteNames.DASHBOARD,
            path: '/dashboard',
            component: () => import('~/pages/DashboardPage.vue').then(r => r.default || r)
        },
        {
            name: ERouteNames.MENU_COLLECTION,
            path: '/m/:slug',
            component: () => import('~/pages/MenuCollectionPage.vue').then(r => r.default || r)
        },
        {
            name: ERouteNames.POSTS_ARCHIVE,
            path: '/n/:slug/archive',
            props: { archive: true },
            component: () => import('~/pages/PostsPage.vue').then(r => r.default || r)
        },
        {
            name: ERouteNames.POSTS,
            path: '/n/:slug',
            component: () => import('~/pages/PostsPage.vue').then(r => r.default || r)
        },
        {
            name: ERouteNames.CUSTOM_PAGE,
            path: '/p/:slug',
            component: () => import('~/pages/CustomPage.vue').then(r => r.default || r)
        },
        {
            name: ERouteNames.RSS,
            path: '/r/:slug',
            component: () => import('~/pages/RssPage.vue').then(r => r.default || r)
        },
        {
            name: ERouteNames.EVENT_CALENDAR,
            path: '/event-calendar/:slug?',
            component: () => import('~/pages/EventCalendarPage.vue').then(r => r.default || r)
        },
        {
            name: ERouteNames.SITEMAP,
            path: '/sitemap',
            component: () => import('~/pages/SitemapPage.vue').then(r => r.default || r)
        },
        {
            name: ERouteNames.POST_DETAIL,
            path: '/t/:id',
            component: () => import('~/pages/SinglePostPage.vue').then(r => r.default || r)
        },
        {
            name: ERouteNames.SEARCH,
            path: '/search/:query?',
            component: () => import('~/pages/SearchPage.vue').then(r => r.default || r)
        },
        {
            path: '/:pathMatch(.*)*',
            name: ERouteNames.NOT_FOUND,
            meta: { layout: 'error' },
            component: () => import('~/pages/NotFoundPage.vue').then(r => r.default || r)
        }
    ],

    scrollBehavior(to: { hash: string }, from, savedPosition) {
        const nuxtApp = useNuxtApp();

        return new Promise((resolve) => {
            nuxtApp.hooks.hook('page:finish', async () => {
                if (to.hash) {
                    // wait 800 ms before scrolling to hash (waiting for page content to load)
                    setTimeout(() => {
                        resolve({
                            el: to.hash,
                            top: 0,
                            behavior: 'smooth'
                        });
                    }, 800);
                }

                if (savedPosition) {
                    // scroll to last saved position if there is no hash in the url
                    resolve(savedPosition);
                }
            });
        });
    }
};
